import { render, staticRenderFns } from "./ServicejobView.vue?vue&type=template&id=4f0cd262&scoped=true"
import script from "./ServicejobView.vue?vue&type=script&lang=js"
export * from "./ServicejobView.vue?vue&type=script&lang=js"
import style0 from "./ServicejobView.vue?vue&type=style&index=0&id=4f0cd262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0cd262",
  null
  
)

export default component.exports